export const aboutContentSetIsLoadingReducerType = 'aboutContentSetIsLoadingReducerType';
export const aboutContentSetBEBuildNumberReducerType = 'aboutContentSetBEBuildNumberReducerType';
export const aboutContentSetDatabasesReducerType = 'aboutContentSetDatabasesReducerType';
export const aboutContentSetUpdateInfoReducerType = 'aboutContentSetUpdateInfoReducerType';
export const aboutContentReducerKey = 'aboutContentReducerKey';
